export default __webpack_public_path__ + "static/media/x.65010d73.svg";